// const handymans = require("./images/handymans.png")
const banner = require("./images/bnner.PNG");

const CTA = () => {
  return (
    <section className="bg-white py-2 mt-2">
      <div className="max-w-screen-xl mx-auto px-4 gap-x-10 justify-between md:flex md:px-8">
        <div className="flex justify-center">
          <img src={banner} className="rounded-xl" alt="banner"/>
       
        </div>
        <div className="max-w-xl mt-5">
          <h3 className="text-gray-600 text-3xl font-extrabold sm:text-4xl">
            Hire temporary skilled handyman fast and free
          </h3>
          <p className="mt-3 text-gray-400">
          Our platform helps you find and hire skilled handyman for appliance repair, plumbing, HVAC, and more. Find your next skilled laborer by filling out the appointment form or calling.
          </p>
          {/* <button
            type="submit"
            className="mt-6 p-3 bg-blue-500 text-white text-lg font-semibold rounded-xl hover:bg-blue-600 transition duration-200"
          >Find handyman near me
          </button> */}
          <h2 className="text-3xl font-extrabold text-red-500">
            Our services
          </h2>
          <ul className="ml-4 font-bold text-gray-400 list-disc my-3">
            <li>Plumbing</li>
            <li>Electrical repair</li>
            <li>Appliance repair jobs</li>
            <li>HVAC and etc.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CTA;
